import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { ascCtaInteraction } from 'helpers/src/gtag';
import { usePreview } from '../provider';

const PreviewLink = ({
  children,
  className,
  hideOnSold = false,
  ...props
}) => {
  const {
    name,
    slug,
    isSold,
    disableLinkOnSold,
  } = usePreview();
  const interactionData = useMemo(() => ({
    element_color: 'overlay',
    element_type: 'digital_retailing',
    event_action_result: 'redirect',
    link_url: slug,
  }), [slug]);
  if (hideOnSold && isSold) {
    return null;
  }

  if (disableLinkOnSold && isSold) {
    return <span {...props}>{children}</span>;
  }

  return (
    <Link
      {...props}
      onClick={() => {
        if (props.onClick) {
          props.onClick();
        }
        ascCtaInteraction(interactionData);
      }}
      className={className}
      title={name}
      to={slug}
    >
      {children}
    </Link>
  );
};

export default styled(PreviewLink)`
  text-decoration: none;
  color: inherit;
  position: relative;
`;
